import Home from "./Home";

export default function App() {
    return (
        <div class="container mx-auto my-60">
            <Home />
        </div>
    );
}
